export const JSON_NOT_PROVIDED = 'No JSON string provided!';
export const JSON_NOT_VALID = `Provided JSON string is not valid JSON!`;
export const MISSING_PROPERTY = 'Missing {0} config property!';
//# sourceMappingURL=constants.js.map